import { ErrorWarningTable } from "./ErrorWarningTable";

export default ErrorWarningTable;
